import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  standalone: false,
})
export class PageHeaderComponent {
  @Input() iconType: any | undefined = undefined;
  @Input() text: string | undefined = undefined;
  @Input() clickable: boolean = false;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  btnClick() {
    this.onClick.emit();
  }
}
